
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="desktop-header">
    <div class="header-text">{{  'CHOOSE_FOLDER_LBL' | translate }}</div>
    <div class="header-icon" (click)="close()" matTooltip="{{ 'CLOSE' | translate }}">
        <ng-container [ngTemplateOutlet]="closeIcon"></ng-container>
    </div>
</div>
<div *ngIf="!selectedMailFolder" class="folder-select-dialog-body">
    <div class="search-form">
        <vnc-input leadingIconName="mdi-magnify" [form]="searchControl" [showClear]="true"
        placeholder="{{'SEARCH_FOLDER'|translate}}" size="l" type="text" >
        </vnc-input>
    </div>
    <cdk-virtual-scroll-viewport class="sub-folders-list-move-folder root-folder" itemSize="30">
        <mat-list>
            <ng-container *cdkVirtualFor="let folder of allFolders| vpFolderNameSearch : searchControl.value; let i = index">
                <mat-list-item (click)="folderItem(folder)" [class.selected-class]="selectedFolder && folder.id === selectedFolder.id">
                    <div class="folder-icon" id="move-folder-list-icon">
                        <!-- <mat-icon [style.color]="folder.rgb">folder</mat-icon> -->
                        <svg width="18" height="18" viewBox="57 58 23 23" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <filter x="-14.4%" y="-13%" width="128.8%" height="126.1%" filterUnits="objectBoundingBox" id="9w5lr2xrta">
                                    <feOffset dy="8" in="SourceAlpha" result="shadowOffsetOuter1"/>
                                    <feGaussianBlur stdDeviation="8" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
                                    <feColorMatrix values="0 0 0 0 0.031372549 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.2 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/>
                                    <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter2"/>
                                    <feGaussianBlur stdDeviation="6" in="shadowOffsetOuter2" result="shadowBlurOuter2"/>
                                    <feColorMatrix values="0 0 0 0 0.0311856736 0 0 0 0 0.177658465 0 0 0 0 0.240432518 0 0 0 0.1 0" in="shadowBlurOuter2" result="shadowMatrixOuter2"/>
                                    <feMerge>
                                        <feMergeNode in="shadowMatrixOuter1"/>
                                        <feMergeNode in="shadowMatrixOuter2"/>
                                        <feMergeNode in="SourceGraphic"/>
                                    </feMerge>
                                </filter>
                            </defs>
                            <g transform="translate(32 -183)" filter="url(#9w5lr2xrta)" [style.fill]="folder.rgb || '#000000'" fill-rule="evenodd">
                                <path d="M34.01 244c.49 0 1.17.263 1.585.606l.116.105.578.578c.362.362 1.022.653 1.553.703l.155.008H45c1.05 0 1.918.82 1.994 1.851L47 248v10c0 1.05-.82 1.918-1.851 1.994L45 260H29c-1.05 0-1.918-.82-1.994-1.851L27 258l.01-12c0-1.05.81-1.918 1.841-1.994L29 244h5.01zm0 2-5 .002L29 258h16v-10h-7.003c-1.012 0-2.183-.458-2.961-1.146l-.161-.15-.578-.579-.027-.015-.185-.081-.076-.029z"/>
                            </g>
                        </svg>
                    </div>
                    <div style="display: flex;justify-content: space-between;width: 100%;">
                        <div class="folder-title disable-select" id="folder-select-folder-name">
                            <span>{{ folder.name }}</span>
                        </div>
                        <div class="arrow-icon" *ngIf="folder?.children?.length > 0" (click)="$event.preventDefault(); $event.stopPropagation();selectFolder(folder)">
                            <mat-icon>chevron_right</mat-icon>
                        </div>
                    </div>
                </mat-list-item>
            </ng-container>
        </mat-list>
    </cdk-virtual-scroll-viewport>
</div>
<div *ngIf="selectedMailFolder && selectedMailFolder?.children?.length > 0" class="folder-select-dialog-body">
    <div class="search-form">
        <vnc-input leadingIconName="mdi-magnify" [form]="searchControl" [showClear]="true"
        placeholder="{{'SEARCH_CALENDAR'|translate}}" size="l" type="text" >
        </vnc-input>
    </div>
    <div class="back-btn-wrapper" (click)="getParentFolder()">
        <vnc-icon-container (click)="getParentFolder()">
            <svg width="18" height="18" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Icon/product/arrow-back" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Icon-24px" transform="translate(4.000000, 4.000000)">
                        <polygon id="Shape" points="16 7 3.83 7 9.42 1.41 8 0 0 8 8 16 9.41 14.59 3.83 9 16 9"></polygon>
                    </g>
                </g>
            </svg>
        </vnc-icon-container>
        <span>{{ 'BACK_TOROOT' | translate}}</span>
    </div>
    <cdk-virtual-scroll-viewport class="sub-folders-list-move-folder" itemSize="30">
        <mat-list>
            <ng-container *cdkVirtualFor="let folder of selectedMailFolder.children| vpFolderNameSearch : searchControl.value; let i = index">
                <mat-list-item (click)="folderItem(folder)" [class.selected-class]="selectedFolder && folder.id === selectedFolder.id">
                    <div class="folder-icon" id="move-folder-list-icon">
                        <!-- <mat-icon [style.color]="folder.rgb">folder</mat-icon> -->
                        <svg width="18" height="18" viewBox="57 58 23 23" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <filter x="-14.4%" y="-13%" width="128.8%" height="126.1%" filterUnits="objectBoundingBox" id="9w5lr2xrta">
                                    <feOffset dy="8" in="SourceAlpha" result="shadowOffsetOuter1"/>
                                    <feGaussianBlur stdDeviation="8" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
                                    <feColorMatrix values="0 0 0 0 0.031372549 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.2 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/>
                                    <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter2"/>
                                    <feGaussianBlur stdDeviation="6" in="shadowOffsetOuter2" result="shadowBlurOuter2"/>
                                    <feColorMatrix values="0 0 0 0 0.0311856736 0 0 0 0 0.177658465 0 0 0 0 0.240432518 0 0 0 0.1 0" in="shadowBlurOuter2" result="shadowMatrixOuter2"/>
                                    <feMerge>
                                        <feMergeNode in="shadowMatrixOuter1"/>
                                        <feMergeNode in="shadowMatrixOuter2"/>
                                        <feMergeNode in="SourceGraphic"/>
                                    </feMerge>
                                </filter>
                            </defs>
                            <g transform="translate(32 -183)" filter="url(#9w5lr2xrta)" [style.fill]="folder.rgb || '#000000'" fill-rule="evenodd">
                                <path d="M34.01 244c.49 0 1.17.263 1.585.606l.116.105.578.578c.362.362 1.022.653 1.553.703l.155.008H45c1.05 0 1.918.82 1.994 1.851L47 248v10c0 1.05-.82 1.918-1.851 1.994L45 260H29c-1.05 0-1.918-.82-1.994-1.851L27 258l.01-12c0-1.05.81-1.918 1.841-1.994L29 244h5.01zm0 2-5 .002L29 258h16v-10h-7.003c-1.012 0-2.183-.458-2.961-1.146l-.161-.15-.578-.579-.027-.015-.185-.081-.076-.029z"/>
                            </g>
                        </svg>
                    </div>
                    <div style="display: flex;justify-content: space-between;width: 100%;">
                        <div class="folder-title disable-select" id="folder-select-folder-name">
                            <span>{{ folder.name }}</span>
                        </div>
                        <div class="arrow-icon" *ngIf="folder?.children?.length > 0" (click)="$event.preventDefault(); $event.stopPropagation();selectFolder(folder)">
                            <mat-icon>chevron_right</mat-icon>
                        </div>
                    </div>
                </mat-list-item>
            </ng-container>
        </mat-list>
    </cdk-virtual-scroll-viewport>
</div>
<vnc-footer class="print-dialog-footer" [secondaryLabel]="'CANCEL' | translate | uppercase"
[primaryLabel]="'COMMON.SAVE' | translate | uppercase"
[type]="'secondary-primary'"
[color]="'white'"
(onSecondaryClick)="close()"
[isPrimaryDisabled]="!selectedFolder"
[ngClass]="{ 'dfb-theme': (currentTheme === 'dfb' && !isFluid) }"
(onPrimaryClick)="save()"></vnc-footer>

<ng-template #closeIcon>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/close-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M18.9497475,5.05025253 C19.3402718,5.44077682 19.3402718,6.0739418 18.9497475,6.46446609 L13.4142136,12 L18.9497475,17.5355339 C19.3402718,17.9260582 19.3402718,18.5592232 18.9497475,18.9497475 C18.5592232,19.3402718 17.9260582,19.3402718 17.5355339,18.9497475 L12,13.4142136 L6.46446609,18.9497475 C6.0739418,19.3402718 5.44077682,19.3402718 5.05025253,18.9497475 C4.65972824,18.5592232 4.65972824,17.9260582 5.05025253,17.5355339 L10.5857864,12 L5.05025253,6.46446609 C4.65972824,6.0739418 4.65972824,5.44077682 5.05025253,5.05025253 C5.44077682,4.65972824 6.0739418,4.65972824 6.46446609,5.05025253 L12,10.5857864 L17.5355339,5.05025253 C17.9260582,4.65972824 18.5592232,4.65972824 18.9497475,5.05025253 Z" id="Path" fill="#8B96A0"></path>
      </g>
    </svg>
</ng-template>